"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Types_1 = require("../../../../../Types");
var Services_1 = require("../../../../../Services");
var Endpoints_1 = require("../../../../../Utils/Endpoints");
var Components_1 = require("../../../../../Components");
var reactstrap_1 = require("reactstrap");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
function ClearQueueEvent(updateCallback, resources, location) {
    var clearQueueEventContentRef = React.createRef();
    return new Types_1.VeriLiteWarningEvent(React.createElement(ClearQueueEventContent, { ref: clearQueueEventContentRef, resources: resources, location: location }), resources.Confirm, [
        new Types_1.VeriLiteEventAction(resources.Yes, "primary", function (currentEvent, closeModalCallback) {
            var _a;
            (_a = clearQueueEventContentRef.current) === null || _a === void 0 ? void 0 : _a.clear();
        }),
        new Types_1.VeriLiteEventAction(resources.Cancel, "secondary", function (currentEvent, closeModalCallback) {
            closeModalCallback();
        })
    ]);
}
exports.ClearQueueEvent = ClearQueueEvent;
var ClearQueueEventContentState;
(function (ClearQueueEventContentState) {
    ClearQueueEventContentState[ClearQueueEventContentState["Initial"] = 0] = "Initial";
    ClearQueueEventContentState[ClearQueueEventContentState["Pending"] = 1] = "Pending";
    ClearQueueEventContentState[ClearQueueEventContentState["Success"] = 2] = "Success";
    ClearQueueEventContentState[ClearQueueEventContentState["Error"] = 3] = "Error";
})(ClearQueueEventContentState || (ClearQueueEventContentState = {}));
var ClearQueueEventContent = /** @class */ (function (_super) {
    __extends(ClearQueueEventContent, _super);
    function ClearQueueEventContent(props) {
        var _this = _super.call(this, props) || this;
        _this.clear = function () {
            _this.updateModal(ClearQueueEventContentState.Pending);
            Services_1.getJson(Endpoints_1.default.ClearDeferredQueue, undefined, true, new Services_1.UserRequestHeaders(__assign(__assign({}, Services_1.Auth.getUser()), { Location: _this.props.location }))).then(function (result) {
                if (result > 0) {
                    _this.setState({ result: result });
                    _this.updateModal(ClearQueueEventContentState.Success);
                }
                else {
                    _this.updateModal(ClearQueueEventContentState.Error);
                }
            }).catch(function (err) {
                console.error(err);
                _this.updateModal(ClearQueueEventContentState.Error);
            });
        };
        _this.updateModal = function (newState) {
            _this.setState({ status: newState });
            var eventHandler = Services_1.EventHandlerProvider.GetInstance();
            var event = eventHandler.GetEvent();
            switch (newState) {
                case ClearQueueEventContentState.Initial:
                    event.title = _this.props.resources.Confirm;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Yes, "primary", function (currentEvent, closeModalCallback) {
                            _this.clear();
                        }),
                        new Types_1.VeriLiteEventAction(_this.props.resources.Cancel, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    break;
                case ClearQueueEventContentState.Pending:
                    event.title = _this.props.resources.LoadingDotDotDot;
                    event.actions = [];
                    break;
                case ClearQueueEventContentState.Success:
                    event.title = _this.props.resources.Success;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Finish, "primary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    break;
                case ClearQueueEventContentState.Error:
                    event.title = _this.props.resources.Error;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    break;
            }
            eventHandler.UpdateEvent();
        };
        _this.state = {
            status: ClearQueueEventContentState.Initial,
            result: ""
        };
        return _this;
    }
    ClearQueueEventContent.prototype.render = function () {
        switch (this.state.status) {
            case ClearQueueEventContentState.Initial:
                return React.createElement("div", null, this.props.resources.QueueClear_ComfirmMessage);
            case ClearQueueEventContentState.Pending:
                return (React.createElement(Components_1.CustomSpinner, null));
            case ClearQueueEventContentState.Success:
                return (React.createElement("div", null,
                    React.createElement(reactstrap_1.Row, { className: "text-success mb-2" },
                        React.createElement(reactstrap_1.Col, null),
                        React.createElement(reactstrap_1.Col, { xs: "auto" },
                            React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "6x", icon: free_solid_svg_icons_1.faCheckCircle })),
                        React.createElement(reactstrap_1.Col, null)),
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, null),
                        React.createElement(reactstrap_1.Col, { xs: "auto" },
                            this.state.result,
                            this.props.resources.QueueClear_SuccessMessage),
                        React.createElement(reactstrap_1.Col, null))));
            case ClearQueueEventContentState.Error:
                return (React.createElement("div", null,
                    React.createElement(reactstrap_1.Row, { className: "text-danger mb-2" },
                        React.createElement(reactstrap_1.Col, null),
                        React.createElement(reactstrap_1.Col, { xs: "auto" },
                            React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "6x", icon: free_solid_svg_icons_1.faTimesCircle })),
                        React.createElement(reactstrap_1.Col, null)),
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, null),
                        React.createElement(reactstrap_1.Col, { xs: "auto" }, this.props.resources.QueueClear_ErrorMessage),
                        React.createElement(reactstrap_1.Col, null))));
        }
    };
    return ClearQueueEventContent;
}(React.Component));
//# sourceMappingURL=ClearQueueEvent.js.map